module.exports = __webpack_public_path__ + "img/stationary-in-position.6a6e4fd8.png";